import {Circle, Fill, Stroke, Style} from "ol/style";

export const LINE_STRING = 'LineString';
export const POINT = 'Point';
export const POLYGON = 'Polygon';
export const MULTI_LINE_STRING = 'MultiLineString';
export const MULTI_POLYGON = 'MultiPolygon';
export const MULTI_POINT = 'MultiPoint';
export const GEOMETRY_COLLECTION = 'GeometryCollection';

function imageStyle(obj) {
    if (obj.kind === 'Circle') {
        const { radius, fill, stroke } = obj;
        return new Circle({
            radius,
            fill: new Fill(fill),
            stroke: new Stroke(stroke)
        });
    } else {
        throw new Error(`Unexpected image kind ${obj.kind}`);
    }
}

function toStyle(obj) {
    return new Style({
        fill: obj.fill ? new Fill(obj.fill) : undefined,
        stroke: obj.stroke ? new Stroke(obj.stroke) : undefined,
        image: obj.image ? imageStyle(obj.image) : undefined
    })
}

export function decode(styleObject) {
    const line = toStyle(styleObject[LINE_STRING]);
    const polygon = toStyle(styleObject[POLYGON]);
    const point = toStyle(styleObject[POINT]);

    const styles = {};

    styles[LINE_STRING] = line;
    styles[MULTI_LINE_STRING] = line;
    styles[POLYGON] = polygon;
    styles[MULTI_POLYGON] = polygon;
    styles[POINT] = point;
    styles[MULTI_POINT] = point;
    styles[GEOMETRY_COLLECTION] = [polygon, line, point];

    return (f) => {
        /** @var f Feature */
        const type = f.getGeometry().getType();
        return styles[type];
    }
}
